import { Component, OnInit, Input } from '@angular/core';
import Product from 'src/app/model/product/product';
import Windowsticker from 'src/app/model/product/windowsticker/windowsticker';
import CustomWindowsticker from 'src/app/model/product/windowsticker/custom-windowsticker';
import { Adjustment } from 'src/app/model/project/adjustment';
import StandardStickerPart from 'src/app/model/product/windowsticker/standard-sticker-part';
import { FileHelper } from '../../../helpers/file-helper';

@Component({
  selector: './adjustment-windowsticker-summary',
  templateUrl: './adjustment-windowsticker-summary.component.html',
  styleUrls: ['./adjustment-windowsticker-summary.component.scss'],
})
export class AdjustmentWindowstickerSummaryComponent implements OnInit {
  @Input()
  product: Product;

  @Input()
  index: number;

  @Input()
  subproject: Adjustment;

  @Input()
  multipleProducts: boolean;

  @Input()
  client = false;

  windowsticker: Windowsticker;

  customWindowSticker: CustomWindowsticker;

  init = false;

  isImage = FileHelper.isImage;

  ngOnInit() {
    this.windowsticker = <Windowsticker>this.product;
    if (this.windowsticker.type === 'CustomWindowSticker') {
      this.customWindowSticker = <CustomWindowsticker>this.windowsticker;
    }
    this.init = true;
  }

  getTitle() {
    if (this.windowsticker.type === 'WindowSticker') {
      return 'Raamsticker (standaard)';
    } else if (this.windowsticker.type === 'CustomWindowSticker') {
      return 'Raamsticker (op maat)';
    }
  }

  getTemporary(temp) {
    if (temp) {
      return 'Tijdelijk';
    }
    return 'Permanent';
  }

  getWindowStickerSize(standardStickerPart: StandardStickerPart) {
    if (standardStickerPart.productSize != null) {
      let formaat = 'Liggend';
      if (
        standardStickerPart.productSize.height ===
        standardStickerPart.productSize.width
      ) {
        formaat = 'Vierkant';
      } else if (
        standardStickerPart.productSize.height >
        standardStickerPart.productSize.width
      ) {
        formaat = 'Staand';
      }
      return (
        formaat +
        ' / ' +
        standardStickerPart.productSize.height +
        ' cm h x ' +
        standardStickerPart.productSize.width +
        ' cm b'
      );
    }
  }

  getWindowStickerSizeWindow() {
    return (
      this.windowsticker.windowLength +
      ' cm h x ' +
      this.windowsticker.windowWidth +
      ' cm b'
    );
  }

  shortenName(name: string) {
    name = name.trim().replace(' ', '');
    let result = name.trim().replace(' ', '');
    let split = name.split('.');
    if (split.length > 1) {
      if (name.length > 8) {
        result =
          split[0].substring(0, 8 - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }
}
